"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebWorkerMeshProxy = void 0;
const transport_1 = require("../../../net/transport");
const linkup_1 = require("../../../net/linkup");
const MeshHost_1 = require("../remoting/MeshHost");
const MeshProxy_1 = require("../remoting/MeshProxy");
const logging_1 = require("../../../util/logging");
//import WebWorker from 'worker-loader!./mesh.worker';
class WebWorkerMeshProxy {
    constructor(worker) {
        this.hostReady = false;
        this.ready = new Promise((resolve, reject) => {
            this.readyCallback = resolve;
            this.timeoutCallback = reject;
            if (this.hostReady) {
                resolve();
            }
        });
        this.meshCommandFwdFn = (cmd) => {
            WebWorkerMeshProxy.meshLogger.trace('Sending mesh command to worker: ' + (cmd === null || cmd === void 0 ? void 0 : cmd.type), cmd);
            try {
                this.worker.postMessage(cmd);
            }
            catch (e) {
                WebWorkerMeshProxy.meshLogger.warning('Could not send mesh command to worker:', cmd);
                WebWorkerMeshProxy.meshLogger.warning(cmd);
                WebWorkerMeshProxy.meshLogger.warning('Error was: ', e);
                throw e;
            }
        };
        this.linkupCommandFwdFn = (cmd) => {
            WebWorkerMeshProxy.linkupLogger.trace('Sending linkup command to worker: ' + (cmd === null || cmd === void 0 ? void 0 : cmd.type), cmd);
            try {
                this.worker.postMessage(cmd);
            }
            catch (e) {
                WebWorkerMeshProxy.linkupLogger.warning('Could not send linkup command to worker:', cmd);
                WebWorkerMeshProxy.linkupLogger.warning(cmd);
                WebWorkerMeshProxy.linkupLogger.warning('Error was: ', e);
                throw e;
            }
        };
        this.webRTCConnEventIngestFn = (ev) => {
            WebWorkerMeshProxy.webRTCLogger.trace('Sending webrtc event to worker: ' + (ev === null || ev === void 0 ? void 0 : ev.type), ev);
            try {
                this.worker.postMessage(ev);
            }
            catch (e) {
                WebWorkerMeshProxy.webRTCLogger.warning('Could not send webrtc event to worker:', ev);
                WebWorkerMeshProxy.webRTCLogger.warning('Error was: ', e);
                throw e;
            }
        };
        this.worker = worker;
        this.worker.onerror = (ev) => {
            console.log('ERROR RECEIVING PROXYIED MESSAGE FROM WEB WORKER:');
            console.log(ev);
        };
        this.worker.onmessage = (ev) => {
            var _a, _b;
            let data = ev.data;
            WebWorkerMeshProxy.meshLogger.debug('Receiving from worker: ' + (data === null || data === void 0 ? void 0 : data.type), ev);
            if (ev.data.type === 'mesh-worker-ready') {
                if (!this.hostReady) {
                    this.hostReady = true;
                    if (this.readyCallback !== undefined) {
                        this.readyCallback();
                    }
                }
            }
            if (linkup_1.LinkupManagerHost.isEvent(data)) {
                WebWorkerMeshProxy.linkupLogger.debug('Ingesting linkup event:', data);
                (_a = this.proxy.linkup) === null || _a === void 0 ? void 0 : _a.linkupManagerEventIngestFn(data);
            }
            if (transport_1.WebRTCConnectionsHost.isCommand(data)) {
                WebWorkerMeshProxy.webRTCLogger.debug('Executing webrtc command:', data);
                if (this.proxy.webRTCConnsHost === undefined) {
                    WebWorkerMeshProxy.webRTCLogger.warning('webRTCConnsHost is undefined, message will be lost (!)');
                }
                try {
                    (_b = this.proxy.webRTCConnsHost) === null || _b === void 0 ? void 0 : _b.execute(data);
                }
                catch (e) {
                    WebWorkerMeshProxy.webRTCLogger.error('Error trying to execute webrtc command:', e);
                }
            }
            if (MeshHost_1.MeshHost.isStreamedReply(data)) {
                WebWorkerMeshProxy.meshLogger.debug('Ingesting streamed reply:', data);
                this.proxy.commandStreamedReplyIngestFn(data);
            }
            if (MeshHost_1.MeshHost.isPeerSourceRequest(data)) {
                WebWorkerMeshProxy.meshLogger.debug('Ingesting peer source request:', data);
                this.proxy.peerSourceRequestIngestFn(data);
            }
        };
        this.proxy = new MeshProxy_1.MeshProxy(this.meshCommandFwdFn, this.linkupCommandFwdFn, this.webRTCConnEventIngestFn);
        this.worker.postMessage({ type: 'mesh-worker-ready-query' });
    }
    getMesh() {
        return this.proxy;
    }
}
exports.WebWorkerMeshProxy = WebWorkerMeshProxy;
WebWorkerMeshProxy.meshLogger = new logging_1.Logger(WebWorkerMeshProxy.name);
WebWorkerMeshProxy.linkupLogger = new logging_1.Logger(WebWorkerMeshProxy.name);
WebWorkerMeshProxy.webRTCLogger = new logging_1.Logger(WebWorkerMeshProxy.name);
//# sourceMappingURL=WebWorkerMeshProxy.js.map